import i18next from "i18next";
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
let base_url_saas = (
  process.env.REACT_APP_IMG_BASE_URL +
  "languages/" +
  process.env.REACT_APP_CC +
  "/" +
  process.env.REACT_APP_ENVIORMENT +
  "/"
).toLowerCase();
i18next
  .use(i18nBackend)
  .use(initReactI18next)
  .use(LanguageDetector)
  // resources,
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "cookie", "path"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: `${base_url_saas}{{lng}}.json`,
    },
  });
export default i18next;
